const ChatRoutes = {
  getChats: "/chat/getChats",
  getMessages: "/chat/getMessages"
}

export default ChatRoutes;